// eslint-disable-next-line import/no-named-as-default
import gql from 'graphql-tag';

export const VERIFY_USER = gql`
  mutation VerifyUser($token: String!) {
    verifyUser(token: $token)
  }
`;
export const SIGN_UP = gql`
  mutation SignUp($email: String!, $password: String!, $name: String!) {
    signUp(email: $email, password: $password, name: $name) {
      email
    }
  }
`;

export const LOG_IN = gql`
  mutation LogIn($email: String!, $password: String!) {
    LogIn(email: $email, password: $password) {
      id
      name
      email
      role
    }
  }
`;

export const FORGOT_PASSWORD = gql`
  mutation forgotPassword($email: String!) {
    forgotPassword(email: $email)
  }
`;

export const CHANGE_PASSWORD_WITH_TOKEN = gql`
  mutation ChangePasswordWithToken($newPassword: String!, $token: String!) {
    ChangePasswordWithToken(newPassword: $newPassword, token: $token)
  }
`;

export const LOG_OUT = gql`
  mutation LogOut {
    LogOut
  }
`;

export const VERIFY_LOGGED_IN = gql`
  mutation CheckIfLoggedIn {
    CheckIfLoggedIn {
      id
      isVerified
      name
      email
      role
      createdAt
    }
  }
`;

export const CONTRACTOR_CREATE = gql`
  mutation ContractorCreate(
    $name: String!
    $ceo: String!
    $phone: String
    $email: String
    $webSite: String
    $about: String!
    $logo: String!
    $photos: [String!]!
    $recommendedBy: [String!]!
    $templateId: String
    $specifications: JSON
  ) {
    contractorCreate(
      name: $name
      ceo: $ceo
      phone: $phone
      email: $email
      webSite: $webSite
      about: $about
      logo: $logo
      photos: $photos
      recommendedBy: $recommendedBy
      templateId: $templateId
      specifications: $specifications
    ) {
      id
      name
      ceo
      about
      logo
      photos
      recommendedBy
      templateId
      specifications
    }
  }
`;

export const CONTRACTOR_UPDATE = gql`
  mutation ContractorUpdate(
    $id: ID!
    $name: String!
    $phone: String
    $email: String
    $webSite: String
    $ceo: String!
    $about: String!
    $logo: String!
    $photos: [String!]!
    $recommendedBy: [String!]!
    $templateId: String
    $specifications: JSON
  ) {
    contractorUpdate(
      id: $id
      name: $name
      phone: $phone
      email: $email
      webSite: $webSite
      ceo: $ceo
      about: $about
      logo: $logo
      photos: $photos
      recommendedBy: $recommendedBy
      templateId: $templateId
      specifications: $specifications
    ) {
      id
      name
      ceo
      about
      logo
      photos
      recommendedBy
      templateId
      specifications
    }
  }
`;

export const CONTRACTOR_DELETE = gql`
  mutation RemoveContractor($id: ID!) {
    removeContractor(id: $id)
  }
`;

export const TEMPLATE_CREATE = gql`
  mutation TemplateCreate(
    $typeformId: String!
    $title: String!
    $link: String!
    $specifications: JSON
  ) {
    templateCreate(
      typeformId: $typeformId
      title: $title
      link: $link
      specifications: $specifications
    ) {
      id
      typeformId
      title
      link
      specifications
    }
  }
`;

export const TEMPLATE_UPDATE = gql`
  mutation TemplateUpdate(
    $id: ID!
    $typeformId: String!
    $title: String!
    $link: String!
    $specifications: JSON
  ) {
    templateUpdate(
      id: $id
      typeformId: $typeformId
      title: $title
      link: $link
      specifications: $specifications
    ) {
      id
      typeformId
      title
      link
      specifications
    }
  }
`;

export const PLAN_CREATE = gql`
  mutation PlanCreate(
    $contractorId: String!
    $title: String!
    $description: String!
    $url: String!
    $image: String!
    $templateId: String
    $specifications: JSON
    $photos: [JSON!]!
    $decorId: String
    $isHidden: Boolean
    $meta: JSON
    $planSVG: String
    $planId: String
    $hasARModel: Boolean
    $arModelLink: String
    $planCost: Float
    $isModular: Boolean
    $isManufactured: Boolean
    $preApproved: Boolean
    $fixPrice: Float
    $sourcePlan: String
    $available: JSON
  ) {
    planCreate(
      contractorId: $contractorId
      title: $title
      description: $description
      url: $url
      image: $image
      templateId: $templateId
      specifications: $specifications
      photos: $photos
      decorId: $decorId
      planSVG: $planSVG
      planId: $planId
      isHidden: $isHidden
      meta: $meta
      hasARModel: $hasARModel
      arModelLink: $arModelLink
      planCost: $planCost
      isModular: $isModular
      isManufactured: $isManufactured
      preApproved: $preApproved
      fixPrice: $fixPrice
      sourcePlan: $sourcePlan
      available: $available
    ) {
      id
      contractorId
      title
      url
      templateId
      specifications
      photos
      meta
      planId
      hasARModel
      arModelLink
      planCost
      isModular
      isManufactured
      preApproved
      fixPrice
      sourcePlan
      available
    }
  }
`;

export const PLAN_UPDATE = gql`
  mutation PlanUpdate(
    $id: ID!
    $contractorId: String!
    $title: String!
    $description: String!
    $url: String!
    $image: String!
    $templateId: String
    $specifications: JSON
    $photos: [JSON!]!
    $decorId: String
    $isHidden: Boolean
    $meta: JSON
    $planSVG: String
    $planId: String
    $hasARModel: Boolean
    $arModelLink: String
    $planCost: Float
    $isModular: Boolean
    $isManufactured: Boolean
    $preApproved: Boolean
    $fixPrice: Float
    $sourcePlan: String
    $available: JSON
  ) {
    planUpdate(
      id: $id
      contractorId: $contractorId
      title: $title
      description: $description
      url: $url
      image: $image
      templateId: $templateId
      specifications: $specifications
      photos: $photos
      decorId: $decorId
      isHidden: $isHidden
      meta: $meta
      planSVG: $planSVG
      planId: $planId
      hasARModel: $hasARModel
      arModelLink: $arModelLink
      planCost: $planCost
      isModular: $isModular
      isManufactured: $isManufactured
      preApproved: $preApproved
      fixPrice: $fixPrice
      sourcePlan: $sourcePlan
      available: $available
    ) {
      id
      contractorId
      description
      title
      url
      templateId
      specifications
      photos
      decorId
      isHidden
      meta
      planId
      hasARModel
      arModelLink
      planCost
      isModular
      isManufactured
      preApproved
      fixPrice
      sourcePlan
      available
    }
  }
`;

export const USER_UPDATE = gql`
  mutation UserUpdate(
    $id: ID!
    $name: String!
    $email: String!
    $role: String!
    $isVerified: Boolean
  ) {
    userUpdate(id: $id, name: $name, email: $email, role: $role, isVerified: $isVerified)
  }
`;

export const USER_DELETE = gql`
  mutation UserUpdate($id: ID!) {
    userDelete(id: $id)
  }
`;

export const MAP_RESULT_CREATE = gql`
  mutation MapResults($snapshot: String!, $user: JSON, $plan: JSON, $map: JSON) {
    mapResultCreate(snapshot: $snapshot, user: $user, map: $map, plan: $plan) {
      id
    }
  }
`;

export const MAP_RESULT_DELETE = gql`
  mutation MapResults($id: ID!) {
    mapResultDelete(id: $id)
  }
`;

export const DIRECTORY_CREATE = gql`
  mutation CreateDirectory($input: DirectoryInput!) {
    createDirectory(input: $input) {
      id
      name
      slug
      values {
        id
        name
        description
        directory
      }
    }
  }
`;

export const DIRECTORY_UPDATE = gql`
  mutation UpdateDirectory($id: ID!, $input: DirectoryInput!) {
    updateDirectory(id: $id, input: $input) {
      id
      name
      slug
      values {
        id
        name
        description
        directory
      }
    }
  }
`;
